// node_modules
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router";

// pages
import { Main } from "./pages/Main/Main";
import { Upload } from "./pages/Upload/Upload";
import { Table } from "./pages/Table/Table";
import { Graph } from "./pages/Graph/Graph";
import { Result } from "./pages/Result/Result";
import { GeneratedPDF } from "./pages/GeneratedPDF/GeneratedPDF";
import { Dashboard } from "./pages/Dashboard/Dashboard";
import { CompanyInfo } from "./pages/CompanyInfo/CompanyInfo";
import { IntegrationSetup } from "./pages/IntegrationSetup/IntegrationSetup";

// styles
import * as styles from "./App.module.css";

// image
import logo from "../public/logo.png";

const App = () => {
  return (
    <div className={styles.mainWrapper}>
      <header className={styles.header}>
        <img src={logo} />
      </header>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/company_info" element={<CompanyInfo />} />
        <Route path="/integration_setup" element={<IntegrationSetup />} />
        <Route path="/upload" element={<Upload />} />
        <Route path="/table" element={<Table />} />
        <Route path="/graph" element={<Graph />} />
        <Route path="/result" element={<Result />} />
        <Route path="/generated_pdf" element={<GeneratedPDF />} />

        <Route path="/dashboard" element={<Dashboard />} />
      </Routes>
    </div>
  );
};

export default App;
